<form #changePasswordForm="ngForm" [formGroup]="confirmationControl" autocomplete="off" class="change-password-dialog">
  <p><span class="user-name-label">User Name: </span><span>{{userName}}</span></p>
  <mat-form-field class="fullWidth">
    <mat-label>Old Password</mat-label>
    <input [(ngModel)]="data.oldPassword" type="password" formControlName="old-password" matInput name="oldPassword" required maxlength="255">
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Password</mat-label>
    <input type="password" formControlName="password" required matInput [(ngModel)]="data.password" name="password"
           pattern="(?=.*[a-zA-Z].*)(?=.*\d.*)\S{8,20}" autocomplete="new-password">
    <mat-error>Invalid password</mat-error>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Confirm password</mat-label>
    <input type="password" formControlName="confirm-password" matInput required
           [(ngModel)]="data.passwordConfirm" name="confirm-password" autocomplete="new-password"
           [errorStateMatcher]="matcher">
    <mat-error *ngIf="confirmationControl.errors?.mismatch">Confirm password does not match Password</mat-error>
  </mat-form-field>
</form>
